<template>
  <div>
    <v-tooltip v-if="isExecutionPage" top>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-bind="attrs"
          v-on="on"
          @click.stop="cancelExecution()"
        >
        mdi-cancel
        </v-icon>
      </template>
      <span>Cancel</span>
    </v-tooltip>
    <v-btn v-else
      class="dialog-button"
      outlined
      color="error"
      @click.stop="cancelExecution()"
    >
    <v-icon left>mdi-cancel</v-icon>
      Cancel Execution
    </v-btn>
  </div>
</template>

<script>
import {
  showConfirmDialog,
  showSuccessDialog,
  showErrorDialog
} from '@/mixins/utils';

export default {
  name: 'CancelExecutionButton',
  props: {
    executionId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
    };
  },
  computed: {
    isExecutionPage() {
      return this.$route.name === 'ExecutionList';
    }
  },
  methods: {
    cancelExecution() {
      const self = this;
      showConfirmDialog(
        'Execution will be canceled',
        'This operation cannot be undone. Are you sure you want to cancel it?',
        function() {
          self.api.cancelExecution(
            self.executionId,
            function(data) {
              showSuccessDialog('', 'Execution was canceled.');
              self.$emit('refresh');
            },
            function(e) {
              console.log(e);
              showErrorDialog(
                'An unexpected error occurred',
                'Try again or let an administrator know if the problem persists.'
              );
            }
          );
        }
      );
    }
  }
};
</script>


<style scoped>
.dialog-button {
  margin-bottom: 5px;
}
</style>
